import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { withFlagService, type FlagService } from '@atlassian/jira-flags';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import { JIRA_UPFLOW_TOUCHPOINT } from '../../common/constants.tsx';
import { addChunkLoadErrorAnalyticsAttribute } from '../../common/utils.tsx';
import DialogContentFallback from './fallback/index.tsx';
import type { DialogContent as DialogContentType } from './main.tsx';
import type { Props } from './types.tsx';

type DefaultProps = {
	flagService: FlagService;
	intl: IntlShape;
};
type RequiredProps = Flow.Diff<Props, DefaultProps>;

const DialogContentLazy = injectIntl(
	withFlagService(
		// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
		lazy<typeof DialogContentType>(() =>
			import(/* webpackChunkName: "async-up-flow-touchpoint-dialog-content" */ './main').then(
				({ DialogContent }) => DialogContent,
			),
		),
	),
);

export const DialogContent = (props: RequiredProps): React.JSX.Element => (
	<JSErrorBoundary
		id={JIRA_UPFLOW_TOUCHPOINT}
		packageName={JIRA_UPFLOW_TOUCHPOINT}
		teamName="luna-growth"
		fallback="flag"
		attributes={addChunkLoadErrorAnalyticsAttribute}
	>
		<Placeholder name="dialog-content-lazy" fallback={<DialogContentFallback />}>
			<DialogContentLazy {...props} />
		</Placeholder>
	</JSErrorBoundary>
);
